<template>
  <div class="index-loading-wrapper">
    <div class="svg-loading-wrapper">
      <svg class="svg-loading" viewBox="0 0 100 100">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#7ECC59"
            d="M84.746 47.114c.84.968 1.528 2.171 2.023 3.532 1.627 4.471.574 8.959-3.87 10.576-4.444 1.618-9.366-.695-10.993-5.166a8.78 8.78 0 0 1-.227-.716l-.668.046c-8.83.608-15.163-7.862-18.359-16.642-3.864-10.618 1.56-22.34 12.114-26.182 10.555-3.842 22.342-1.122 26.11 12.27 2.644 9.403-1.573 17.063-6.13 22.282zM42.767 61.438c.954 1.012 1.728 2.314 2.27 3.806 1.628 4.471.575 8.96-3.87 10.577-4.443 1.617-9.365-.696-10.993-5.167a8.785 8.785 0 0 1-.209-.653l-1.132.078c-8.675.597-14.896-7.723-18.035-16.349-3.796-10.43 1.531-21.946 11.9-25.72 10.369-3.774 21.948-1.102 25.649 12.054 2.513 8.933-1.279 16.264-5.58 21.374z"
          />
          <path
            fill="#EFE1D5"
            d="M60.13 68.364c-.59-9.62.808-23.008 4.09-24.09 4.38-1.443 20.078 15.522 22.655 22.6 2.576 7.08-1.623 13.292-8.66 15.853-4.758 1.732-9.596 1.35-13.026-1.267-.709 4.524-4.282 8.201-9.295 10.026-7.036 2.561-14.246.501-16.823-6.578-2.576-7.079-1.551-30.431 2.828-31.874 3.206-1.057 12.482 7.756 18.231 15.33z"
          />
          <path
            fill="#90E169"
            d="M74.232 49.925c-.735 1.9-1.39 4.122-1.42 6.06-.074 4.501 1.515 7.887 1.515 7.887L47.04 73.804s-1.405-4.194-3.898-7.02c-.894-1.015-2.513-1.846-4.22-2.494-1.096-.342-2.11-.537-2.663-.428-9.683 1.922-19.605-3.49-23.106-13.11-3.6-9.893.861-20.744 10.024-25.287C22.694 16.273 28.16 7.474 37.21 4.18c9.051-3.295 18.895-.068 24.432 7.285 9.94-2.41 20.332 3.035 23.933 12.928 3.684 10.12-5.908 20.824-11.344 25.532z"
          />
          <path
            fill="#6CBC45"
            d="M56.202 51.793l-.356-.979c1.245-1.925 2.736-4.664 4.187-7.775 2.94-6.303 4.6-11.75 3.71-12.165-.89-.415-3.995 4.358-6.934 10.661a79.686 79.686 0 0 0-2.335 5.51l-4.346-11.942c.972-1.302 2.18-3.395 3.319-5.836 2.025-4.343 3.062-8.146 2.316-8.494-.747-.348-2.993 2.89-5.019 7.234a43.774 43.774 0 0 0-1.746 4.286c-3.197-8.073-5.945-13.695-6.674-13.43-.712.26.711 6.064 3.333 14.015a54.265 54.265 0 0 0-4.175-2.159c-4.781-2.23-8.94-3.432-9.288-2.686-.348.747 3.247 3.16 8.028 5.389 2.442 1.138 4.722 2.01 6.414 2.49l4.495 12.35a79.686 79.686 0 0 0-5.33-2.72c-6.303-2.94-11.75-4.6-12.165-3.71-.415.89 4.358 3.995 10.661 6.934 3.112 1.451 6.014 2.59 8.206 3.265l.356.979c.002.377.08.615.24.69a.257.257 0 0 0 .013.005l6.504 17.868 3.343-1.217-6.504-17.868a.257.257 0 0 0 .007-.012c.074-.16-.02-.393-.26-.683z"
          />
          <path
            fill="#FFF7EF"
            d="M69.718 93.097c8.889-3.235 14.193-11.083 10.938-20.025-3.254-8.941-23.084-30.37-28.616-28.547-5.531 1.824-6.826 31.321-3.572 40.263 3.255 8.941 12.362 11.544 21.25 8.309z"
          />
        </g>
      </svg>
      <div class="shadow"></div>
    </div>
  </div>
</template>

<style lang="less">
.index-loading-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #fff;
}
.index-loading-wrapper .svg-loading-wrapper {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
}
.svg-loading-wrapper .svg-loading {
  width: 100px;
  height: 100px;
  -webkit-transform: translateY(0);
  transform: translateY(0);
  -webkit-animation: bounce 0.8s ease-in-out infinite;
  animation: bounce 0.8s ease-in-out infinite;
}
.svg-loading-wrapper .shadow {
  width: 10px;
  height: 8px;
  left: 0;
  right: 0;
  margin: -5px auto auto auto;
  border-radius: 50%;
  background: #dddddd;
  box-shadow: 0 0 8px #999999;
  -webkit-animation: shadow 0.8s ease-in-out infinite;
  animation: shadow 0.8s ease-in-out infinite;
}
@keyframes bounce {
  0%,
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  50% {
    -webkit-transform: translateY(-50px);
    transform: translateY(-50px);
  }
}
@keyframes shadow {
  0%,
  100% {
    -webkit-transform: scaleX(3.8);
    transform: scaleX(3.8);
  }
  50% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}
</style>
